// extracted by mini-css-extract-plugin
module.exports = {"Logo":"CornerCardLogo_Logo__1NkH1","ContactUs":"CornerCardLogo_ContactUs__3yg39"};